<div class="player-wrapper" [class.responsible]="responsible" [class.with-cta-simple-expand]="video.userVideo.ctaSimple && video.userVideo.ctaSimple.showType == 2 && video.userVideo.ctaSimple.isShown">
  <div [innerHTML]="style"></div>

  <div class="live-thumbnail" [class.show]="showLiveThumbnail" (click)="liveThumbnailClicked($event)">
    <div class="thumbnail"><img #liveThumbnailImageRef style="width:100%;" [src]="video.userVideo.thumbnailPath" (load)="onLiveThumbnailImageLoad(liveThumbnailImageRef)"></div>
    <div class="play-icon" [style.background-color]="playlist.color"></div>
  </div>

  <div class="video-wrapper" [class.has-live]="video.userVideo.live" [class.has-form-expand]="video.userVideo.formExpand" [style.height]="playerHeight">

    <div class="live-guide-wrapper" *ngIf="liveStatus == 'before-start' || liveStatus == 'after-end'">
      <div *ngIf="liveStatus == 'before-start'" class="live-guide live-guide-before-start">
        <div class="live-guide-container" [class.has-thumbnail]="video.userVideo.live.beforeStart.backgroundImage">
          <div class="live-guide-content">
            <div class="title">{{video.userVideo.live.beforeStart.title}}</div>
            <div class="description"><span id="liveStartDescription" [innerHTML]="video.userVideo.live.beforeStart.description | linky:{stripPrefix:false}"></span></div>
            <div class="date">{{video.userVideo.live.getStartDate() | date:"M月d日 HH:mm"}} 開始予定</div>
          </div>
        </div>
        <div class="live-guide-bg-wrapper">
          <ng-container *ngIf="video.userVideo.live.beforeStart.backgroundImage">
            <div class="live-guide-bg" [style.background-image]="'url(' + video.userVideo.live.beforeStart.backgroundImage + ')'"></div>
          </ng-container>
          <ng-container *ngIf="! video.userVideo.live.beforeStart.backgroundImage">
            <div class="live-guide-bg" [style.background-image]="'url(' + video.userVideo.thumbnailPath + ')'"></div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="liveStatus == 'after-end'" class="live-guide live-guide-after-end">
        <div class="live-guide-container" [class.has-thumbnail]="video.userVideo.live.afterEnd.backgroundImage">
          <div class="live-guide-content">
            <div class="title">{{video.userVideo.live.afterEnd.title}}</div>
            <div class="description"><span id="liveEndDescription" [innerHTML]="video.userVideo.live.afterEnd.description | linky:{stripPrefix:false}"></span></div>
          </div>
        </div>
        <div class="live-guide-bg-wrapper">
          <ng-container *ngIf="video.userVideo.live.afterEnd.backgroundImage">
            <div class="live-guide-bg" [style.background-image]="'url(' + video.userVideo.live.afterEnd.backgroundImage + ')'"></div>
          </ng-container>
          <ng-container *ngIf="! video.userVideo.live.afterEnd.backgroundImage">
            <div class="live-guide-bg" [style.background-image]="'url(' + video.userVideo.thumbnailPath + ')'"></div>
          </ng-container>
        </div>
      </div>
    </div>
    
    <div class="video-container" [class.visible]="liveStatus != 'before-start' && liveStatus != 'after-end'">
      <div [attr.id]="'video-' + video.hash"></div>
    </div>
  </div>

  <div class="form-expand-wrapper" *ngIf="video.userVideo.formExpand">
    <app-form-expand [formExpand]="video.userVideo.formExpand" (formExpandInputed)="formExpandInputedEvent($event)"></app-form-expand>
  </div>

  <div *ngIf="video.userVideo.ctaSimple && video.userVideo.ctaSimple.showType == CtaShowType.expand" id="cta-expand-wrapper" class="cta-expand-wrapper" [class.show]="video.userVideo.ctaSimple && video.userVideo.ctaSimple.showType == 2 && video.userVideo.ctaSimple.isShown">
    <app-cta-simple-expand #ctaSimpleExpandComponent [userVideo]="video.userVideo" [color]="playlist.color"></app-cta-simple-expand>
  </div>

</div>
